import { Component, OnInit } from '@angular/core';
import { FormService } from '../services/form.service';
import { UntypedFormGroup, Validators } from "@angular/forms";
import { ApiService } from "../services/api.service";
import { animate, style, transition, trigger } from "@angular/animations";
import { environment } from "../../environments/environment";
import Bugsnag from "@bugsnag/js";

export interface Question {

	name: string,
	title: string,
	question: string,
	class: string,
	extra_1_type?: number,
	extra_1_question?: string,
	extra_1_options?: string,
	extra_1_class?: string,

	extra_2_type?: number,
	extra_2_question?: string,
	extra_2_options?: string,
	extra_2_class?: string,

	key: number;

	double?: number,
}
export type Questions = Question[];

@Component( {
	selector: 'app-thank-you',
	templateUrl: './thank-you.component.html',
	styleUrls: ['./thank-you.component.scss'],
	animations: [
		trigger('slideInOut', [
			transition(':enter', [
				style({opacity: 0}),
				animate('300ms ease-in-out', style({opacity: 1}))
			]),
			transition(':leave', [
				style({opacity: 1}),
				animate('300ms ease-in-out', style({opacity: 0}))
			]),
		])
	]
} )
export class ThankYouComponent implements OnInit {

	public thirdPartyForm !: UntypedFormGroup
	formGroupName : string = 'thirdPartyForm'
	private debugQuestions : boolean = false;
	private debugCountDownAndRedirect : boolean = false;
	public loadingAnimationBeforeRedirecting : boolean = false;

	constructor( public formService: FormService,
	             private apiService: ApiService ) {
	}

	ngOnInit(): void {

		this.thirdPartyForm = this.formService.thirdPartyForm as UntypedFormGroup;

		// == Debugging questions ==
		if( this.debugQuestions && ! environment.production ) {

			this.apiService.getTestQuestions().subscribe( response => {

				this.formService.questions = Object.values( JSON.parse( response ) );
				this.formService.setupThirdPartyForm();
			} );
		}

		if( this.debugCountDownAndRedirect && ! environment.production ) {

			// This requires formService.formActive to be on false as well
			// This does not work together with the third party questions
			setTimeout( () => {

				this.formService.token = 'testing';
				this.formService.countDownAndRedirect();
			}, 1000 );
		}

		// == END DEBUGGING == //
	}

	onSubmit() {

		if( this.thirdPartyForm.invalid ) {

			var firstErrorFound = false;

			// For unknown reasons we have to mark every single field as dirty manually.
			// This is probably because we create the fields dynamically and something isn't build as intended there
			Object.keys(this.thirdPartyForm.controls).forEach(key => {

				// If is required
				if( this.thirdPartyForm.controls[key].hasValidator( Validators.required ) ) {

					if( ! firstErrorFound ) {

						// Get form element
						var formEl = document.getElementById( 'third-party-questions-form' );

						// Get form control html element
						var formElementEl = document.getElementById( 'key-' + key );

						// Check if elements exists
						if( formElementEl && formEl ) {

							// Scroll questions form
							formEl.scroll({
								top: formElementEl.offsetTop,
								behavior: 'smooth',
							} );
						}

						// Mark as found to not scroll again
						firstErrorFound = true;
					}

					this.thirdPartyForm.controls[key].markAsDirty();
				}
			} );
			return;
		}

		// Add the data to any potential bugsnag report
		Bugsnag.addMetadata('ThirdPartyQuestions', this.thirdPartyForm.value );

		// Put the request in here
		var body = JSON.stringify( this.thirdPartyForm.value );

		console.log( body );

		this.formService.questionsActive = false;
		this.formService.countDownAndRedirect();

		// Post to super-form
		this.apiService.postQuestions(body).subscribe(response => {

			console.log( 'raw response: ' );
			console.log( response );

			console.log( '==========' );
			response = JSON.parse( response );

			console.log( 'parsed response: ' );
			console.log(response);

			console.log( '==========' );

			// We don't really care about the response
		} );
	}

	waitAndGoToDashboard( event:any ) {

		// Stop linking
		event.preventDefault();

		// Wait time 1.5s
		var waitTime = 1500;

		// Add loader in button
		this.loadingAnimationBeforeRedirecting = true;

		// Wait
		setTimeout( () => {
			window.location.href = this.formService.dashboardUrl;
		}, waitTime );
	}
}
